export default __webpack_public_path__ + "static/media/CheckboxFilled.14ac01b9.svg";